module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 _.each(sliced_payment_items, function(item) { 
__p+='\n<td>'+
((__t=( item ))==null?'':_.escape(__t))+
'</td>\n';
 }) 
__p+='\n<td class="settlement_accounts grid3">\n  <select name="settlement_account"></select>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./parentpay/templates/bankaccount/row.html
// module id = 219
// module chunks = 0